import React from "react";
import isEmpty from "../../../../../store/validation/is-Empty";

export const ViewAboutSection = (props) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Business Name</h4>
          <p className="font_18_r c_gray">{props.data.restaurant_name}</p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Phone No.</h4>
          {!isEmpty(props.data.contact_detail) &&
            props.data.contact_detail.map((singleitem, index) => {
              return (
                <React.Fragment key={index}>
                  <p className="font_18_r c_gray mb-2">
                    {singleitem.country_code + " " + singleitem.mobile_no}
                  </p>
                </React.Fragment>
              );
            })}
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Business Address</h4>
          <p className="font_18_r c_gray">{props.data.restaurant_address}</p>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Area</h4>
          <p className="font_18_r c_gray">{props.data.area}</p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">City</h4>
          <p className="font_18_r c_gray">{props.data.city}</p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Enquiry Email</h4>
          {!isEmpty(props.data.enquiry_email) &&
            props.data.enquiry_email.map((singleitem, index) => {
              return (
                <React.Fragment key={index}>
                  <p className="font_18_r c_gray mb-2">{singleitem}</p>
                </React.Fragment>
              );
            })}
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Pin/Zip code</h4>
          <p className="font_18_r c_gray">{props.data.pinCode}</p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Country</h4>
          <p className="font_18_r c_gray">{props.data.country}</p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Currency</h4>
          <p className="font_18_r c_gray">{props.data.currency}</p>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Time zone</h4>
          <p className="font_18_r c_gray">{props.data.timezone}</p>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-12">
          <h4 className="font_20_m mb-3 c_red">Point of contact</h4>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Name / Role</h4>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Enquiry Email</h4>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Phone No.</h4>
        </div>
        <div className="col-12">
          {!isEmpty(props.data.point_of_contact) &&
            props.data.point_of_contact.map((contact, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="row mb-4 mt-2">
                    <div className="col-4">
                      <p className="font_18_r c_gray">
                        {contact.firstName + " " + contact.lastName}
                      </p>
                      <p className="font_14_r c_gray">
                        ({contact.selected_position})
                      </p>
                    </div>
                    <div className="col-4">
                      {!isEmpty(contact.enquiry_emails) &&
                        contact.enquiry_emails.map((email, index) => {
                          return (
                            <React.Fragment key={index}>
                              <p className="font_18_r c_gray">{email}</p>
                            </React.Fragment>
                          );
                        })}
                    </div>
                    <div className="col-4">
                      {!isEmpty(contact.phone_numbers) &&
                        contact.phone_numbers.map((phone, index) => {
                          return (
                            <React.Fragment key={index}>
                              <p className="font_18_r c_gray">
                                {phone.country_code + " " + phone.mobile_no}
                              </p>
                            </React.Fragment>
                          );
                        })}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-12">
          <h4 className="font_20_m mb-3 c_red">Business Details</h4>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Business Description</h4>
          <p className="font_18_r c_gray">
            {props.data.restaurant_description}
          </p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Logo</h4>
          <img
            src={props.data.logo_url}
            alt="Business logo"
            title="Business logo"
            className="img-fluid about_logo_image"
          />
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Photos</h4>
          <div className="col-12">
            <div className="row">
              {!isEmpty(props.data.restaurant_pictures) &&
                props.data.restaurant_pictures.map((images, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="col-5 p-0 m-1">
                        <img
                          src={images}
                          alt="Business Pic"
                          title="Business Pic"
                          className="img-fluid about_photos_image"
                        />
                      </div>
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Video</h4>
          {props.data.restaurant_video === undefined ||
          props.data.restaurant_video === null ||
          props.data.restaurant_video === "" ? (
            "Video Not Available"
          ) : (
            <video width="75%" height="auto" controls>
              <source src={props.data.restaurant_video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          {/* <img
            src={props.data.restaurant_video}
            alt="video"
            title="video"
            className="img-fluid about_logo_image" */}
          {/* /> */}
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Things To Do Nearby*</h4>
          <p className="font_18_r c_gray">{props.data.area}</p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Chain Details</h4>
          <div className="col-12 p-0 d-flex align-items-center">
            <img
              src={props.data.logo_url}
              alt="Business logo"
              title="Business logo"
              className="img-fluid about_logo_image mr-3"
            />
            <p className="font_20_m">{props.data.restaurant_name}</p>
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        {/* /********* Section Left *********/}
        <div className="col-4">
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Business Type</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_restaurant_type) &&
                props.data.selected_restaurant_type.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Parking</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_parking_type) &&
                props.data.selected_parking_type.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Accessibility</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_accessibilty) &&
                props.data.selected_accessibilty.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Point of Sale System</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selectedPointOfSale) &&
                props.data.selectedPointOfSale.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
        </div>
        {/* /********* Section Middle *********/}
        <div className="col-4">
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Cost for two</h4>
            <p className="font_18_r c_gray">
              Approx. {props.data.cost_for_two} INR
            </p>
          </div>
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Pets Allowed</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_pet_allowance) &&
                props.data.selected_pet_allowance.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Other Features</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_other_features) &&
                props.data.selected_other_features.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
        </div>
        {/* /********* Section Right *********/}
        <div className="col-4">
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Payment Methods</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_payment_methods) &&
                props.data.selected_payment_methods.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Dress Code</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_dress_code) &&
                props.data.selected_dress_code.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
          <div className="col-12 p-0 mb-4">
            <h4 className="font_20_m mb-2">Services Offered</h4>
            <p className="font_18_r c_gray">
              {!isEmpty(props.data.selected_services_offered) &&
                props.data.selected_services_offered.map((data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                })}
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
